import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';

const PhotoDetails = () => {
  const { foldername } = useParams();
  const [thumbnails, setThumbnails] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchThumbnails = async () => {
      const apiUrl = `/api/thumbnails/${foldername}`;
      try {
        const response = await fetch(apiUrl);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const json = await response.json();
        setThumbnails(json); // Assuming json is an array of filenames
      } catch (error) {
        setError(error.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchThumbnails();
  }, [foldername]);

  if (isLoading) return <Container>Loading...</Container>;
  if (error) return <Container>Error: {error}</Container>;

  return (
    <Container>
      <h1>Photo Details for {foldername}</h1>
      <Row>
        {thumbnails.map((filename, index) => (
          <Col key={index} xs={6} md={4} lg={3}>
            <Link to={`/members/photos/${foldername}/${filename}`}>
              <img 
                src={`/members/photosthumbs/${foldername}/${filename}`} 
                alt={filename} 
                className="img-fluid"
              />
            </Link>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default PhotoDetails;
